/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { PermissionFromJSON, PermissionToJSON, } from './Permission';
/**
 * Check if a given object implements the UserCreationRequest interface.
 */
export function instanceOfUserCreationRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "active" in value;
    return isInstance;
}
export function UserCreationRequestFromJSON(json) {
    return UserCreationRequestFromJSONTyped(json, false);
}
export function UserCreationRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'password': !exists(json, 'password') ? undefined : json['password'],
        'username': !exists(json, 'username') ? undefined : json['username'],
        'temporaryPassword': !exists(json, 'temporaryPassword') ? undefined : json['temporaryPassword'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'permissions': !exists(json, 'permissions') ? undefined : (json['permissions'].map(PermissionFromJSON)),
        'organisationId': !exists(json, 'organisationId') ? undefined : json['organisationId'],
        'active': json['active']
    };
}
export function UserCreationRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'password': value.password,
        'username': value.username,
        'temporaryPassword': value.temporaryPassword,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'email': value.email,
        'permissions': value.permissions === undefined ? undefined : (value.permissions.map(PermissionToJSON)),
        'organisationId': value.organisationId,
        'active': value.active
    };
}
